import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { useSelector } from 'react-redux';
import api from "../Api";
import Popup from "../components/PopUP";


function Profile(){
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showOld, setShowOld] = useState(false);
    const [showNew, setShowNew] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const user = useSelector((state) => state.user.user.user_details);
    const [errors, setErrors] = useState({});
    const [toast, setToast] = useState(null);

    const showToast = (message, type) => {
        setToast({ message, type });
      };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};

        if (oldPassword.length < 8) {
            newErrors.old_password = "Old password must be at least 8 characters";
        }

        if (newPassword.length < 8) {
            newErrors.new_password = "New password must be at least 8 characters";
        }

        if (confirmPassword.length < 8) {
            newErrors.confirm_password = "Confirm Password must be at least 8 characters";
        }

        if (newPassword !== confirmPassword) {
            console.log("New password and confirm password do not match!");
            newErrors.confirm_password = "New password and confirm password do not match!"
        }

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const data={
            "old_password": oldPassword,
            "new_password": newPassword,
            "confirm_password": confirmPassword
        }

        try{
            const response = await api.post("/user-service/auth/change-password", data);
            showToast(response.data.detail, 'success');

            setOldPassword("");
            setNewPassword("");
            setConfirmPassword("");
            setErrors({})
        }
        catch (error){
        if (error.response && error.response.data && error.response.data.detail) {
            const errorDetail = error.response.data.detail[0]; 
            if (errorDetail.loc[1] === 'old_password'){
                setErrors({ old_password: errorDetail.msg });
            }
            else if (errorDetail.loc[1] === 'new_password'){
                setErrors({ new_password: errorDetail.msg });
            }
            else if (errorDetail.loc[1] === 'confirm_password'){
                setErrors({ confirm_password: errorDetail.msg });
            }
        }
        else{
            setErrors(error.response.data)
        }
        showToast('Failed to change password. Please try again.', 'danger');
        }
    };


    return(
        <>
        <Sidebar/>
        <div className="main-wrapper">
            <Header/>
            <Popup
                message={toast?.message}
                type={toast?.type}
                onClose={() => setToast(null)}
                duration={3000}
                />

            <div className="content-wrapper">
                <section className="main-section spacer-y">
                <div className="container">
                <div className="row gy-4">
                    <div className="col-xl-12">
                    <div className="common_main_bg_wrapper">
                        <div className="common_main_heading_wrapper">
                        <div className="vstack">
                            <h1>Profile Detail</h1>
                        </div>
                        </div>
                    </div>

                    <div className="common-outer-card mt-4">
                        <div className="common_sub_heading_wrapper align-items-start">
                        <div className="main_profile_blk hstack">
                            {/* <div className="profile_img">
                            <img src="assets/images/user.png" alt="Profile" />
                            <input
                                type="file"
                                className="d-none"
                                id="profileUpload"
                            />
                            <label htmlFor="profileUpload">
                                <img
                                src="assets/images/camera.svg"
                                alt="Upload Icon"
                                />
                            </label>
                            </div> */}
                            <div className="profile_info">
                            <h2 className="text-capitalize">{user.first_name} {user.last_name}</h2>
                            <p>{user.email}</p>
                            </div>
                        </div>

                        {/* <Link
                            to=""
                            className="bg_primary_outline_btn rounded-pill"
                        >
                            <img
                            src="assets/images/edit-primary-icon.svg"
                            alt="edit"
                            />{" "}
                            Edit
                        </Link> */}
                        </div>

                        <div className="common_content_blk pt-5">
                        <div className="row g-4">
                        <div className="col-12 col-sm-6 col-md-4">
                         <div className="profile_wrapper">
                            <div className="common_sub_heading_wrapper p-0 border-0 mb-3">
                                <h2>Change Password</h2>
                            </div>

                            {/* Old Password */}
                            <div className="form_field">
                                <label>Old Password</label>
                                <div className="profile_fields input_field">
                                <input
                                    type={showOld ? "text" : "password"}
                                    className="form-control w-100"
                                    id="oldPassword"
                                    placeholder="Enter old password"
                                    value={oldPassword}
                                    onChange={(e) => setOldPassword(e.target.value)}
                                />
                                <span className="eye-icon" onClick={() => setShowOld(!showOld)}>
                                    <i
                                    className={
                                        showOld ? "fa-regular fa-eye" : "fa-regular fa-eye-slash"
                                    }
                                    ></i>
                                </span>
                                <span className="error">
                                    {errors.old_password}
                                </span>
                                </div>
                            </div>

                            {/* New Password */}
                            <div className="form_field">
                                <label>New Password</label>
                                <div className="profile_fields input_field">
                                <input
                                    type={showNew ? "text" : "password"}
                                    className="form-control w-100"
                                    id="newPassword"
                                    placeholder="Enter new password"
                                    value={newPassword}
                                    onChange={(e) => setNewPassword(e.target.value)}
                                />
                                <span className="eye-icon" onClick={() => setShowNew(!showNew)}>
                                    <i
                                    className={
                                        showNew ? "fa-regular fa-eye" : "fa-regular fa-eye-slash"
                                    }
                                    ></i>
                                </span>
                                <span className="error">
                                    {errors.new_password}
                                </span>
                                </div>
                            </div>

                            {/* Confirm Password */}
                            <div className="form_field">
                                <label>Confirm Password</label>
                                <div className="profile_fields input_field">
                                <input
                                    type={showConfirm ? "text" : "password"}
                                    className="form-control w-100"
                                    id="confirmPassword"
                                    placeholder="Enter confirm password"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                                <span
                                    className="eye-icon"
                                    onClick={() => setShowConfirm(!showConfirm)}
                                >
                                    <i
                                    className={
                                        showConfirm ? "fa-regular fa-eye" : "fa-regular fa-eye-slash"
                                    }
                                    ></i>
                                </span>
                                <span className="error">
                                    {errors.confirm_password}
                                </span>
                                </div>
                            </div>

                            {/* Submit Button */}
                            {/* Buttons */}
                            <div className="main_action_blk hstack justify-content-start">
                                <button className="bg_primary_outline_btn rounded-pill">
                                Cancel
                                </button>
                                <button className="primary-btn rounded-pill" onClick={handleSubmit}>Save</button>
                            </div>
                            </div>
                            </div>
                        </div>

                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </section>
        </div>
        </div>
        </>
    )
}



export default Profile;
